var map = {
	"./account.js": 980,
	"./address.js": 981,
	"./bindForm.js": 982,
	"./check.js": 983,
	"./coursesDetail.js": 984,
	"./download.js": 985,
	"./evaluation.js": 986,
	"./goods.js": 987,
	"./index.js": 272,
	"./login.js": 988,
	"./order.js": 989,
	"./page.js": 990,
	"./teacher.js": 991,
	"./test.js": 992,
	"./unpaidCourses.js": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 979;